<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel" i18n="@@">Assignee Management</h5>

    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>

<div *ngIf="userListLoading"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div class="modal-body p-4">
    <div class="search-box mb-3">
        <input type="text" class="form-control bg-light border-light" placeholder="Search for an assignee" [(ngModel)]="searchTerm" (keyup)="searchTermUpdated()">
        <i class="ri-search-line search-icon"></i>
    </div>

    <div class="mb-4 d-flex align-items-center">
        <div class="me-2">
            <h5 class="mb-0 fs-13">Assignees:</h5>
        </div>
        <div class="avatar-group justify-content-center">

            <a *ngFor="let assignee of assigneesList" class="avatar-group-item"
                ngbTooltip="{{assignee.fullName}}" placement="top" data-bs-toggle="tooltip">
                <img [src]="assignee.listPhoto" class=" avatar-xs rounded-circle" (click)="removeUserFromListOfAssignees(assignee)">
            </a>

        </div>
    </div>
    <div class="">
        <div style="height: 400px; overflow: auto;">
            <div class="px-2">
                <div class="card card-no-border" id="draftList" style="margin-bottom: 0;">
                    <div class="dropdown-item py-2 px-3" style="cursor: pointer;" *ngFor="let data of userListItems"
                        id="item_{{data.id}}">
                        <div class="d-flex align-items-center">
                            <div class="d-flex align-items-center"
                                style="overflow: hidden;text-overflow: ellipsis; width: 100%;">
                                <div class="flex-shrink-0 gap-2">
                                    <img [src]="data.listPhoto" alt="" class="border border-solid avatar-xs rounded-circle me-2">
                                </div>
                                <div class="mb-0 fs-13">
                                    {{data.fullName}}
                                </div>
                            </div>
                            <div class="flex-shrink-0">
                                <button *ngIf="!data.isInList" type="button" (click)="addToListOfAssignees(data)" class="btn btn-light btn-sm">Add</button>
                                <button *ngIf="data.isInList" type="button"  (click)="removeUserFromListOfAssignees(data)" class="btn btn-light btn-sm">Remove</button>
                            </div>
                            
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button (click)="onUpdate()" type="button" class="btn btn-success w-xs">Update</button>
</div>